import {createContext} from 'react';

export default createContext<LocaleContextValue>({
	locale: 'en',
});

export interface LocaleContextValue {
	locale: string;
}